(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    class MegaMenuWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.links = this.querySelectorAll('.td-mega-menu-panel__link[data-target]');
    this.panels = this.querySelectorAll('.td-mega-menu-panel__item');
    this.setupEventListeners();
    this.initializeDefaultState();
  }

  setupEventListeners() {
    this.links.forEach((link, index) => {
      // Only add hover listeners to links that have child content
      const targetId = link.getAttribute('data-target');
      const targetPanel = this.querySelector(`#${targetId}`);
      const anchor = link.querySelector('a');
      
      if (targetPanel && targetPanel.children.length > 0) {
        link.addEventListener('mouseenter', () => {
           this.handleLinkHover(link);
        });

        // Add focus listener for keyboard navigation
        if (anchor) {
          anchor.addEventListener('focus', () => {
            this.handleLinkHover(link);
          });
          
          // Add keydown listener for arrow navigation
          anchor.addEventListener('keydown', (e) => {
            this.handleKeydown(e, index);
          });
        }
      }
    });

    // Add listeners for panel content navigation
    this.panels.forEach((panel, index) => {
      panel.addEventListener('keydown', (e) => {
        this.handlePanelKeydown(e, index);
      });
    });

    // Listen for mouse leaving the entire mega menu wrapper
    this.addEventListener('mouseleave', () => {
      // Reset all aria-expanded attributes to false on all links
      this.links.forEach(link => {
        const anchor = link.querySelector('a');
        if (anchor) anchor.setAttribute('aria-expanded', 'false');
      });
    });
  }

  handleKeydown(event, index) {
    const isArrowUp = event.key === 'ArrowUp';
    const isArrowDown = event.key === 'ArrowDown';
    const isArrowRight = event.key === 'ArrowRight';

    if (isArrowUp || isArrowDown) {
      event.preventDefault();
      event.stopPropagation();
      const direction = isArrowUp ? -1 : 1;
      const nextIndex = (index + direction + this.links.length) % this.links.length;
      const nextLink = this.links[nextIndex];
      const nextAnchor = nextLink.querySelector('a');
      if (nextAnchor) {
        nextAnchor.focus();
      }
    } else if (isArrowRight) {
       event.preventDefault();
       const targetId = this.links[index].getAttribute('data-target');
       const targetPanel = this.querySelector(`#${targetId}`);
       if (targetPanel) {
         // Find first focusable element in the panel
         const focusable = targetPanel.querySelector('a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
         if (focusable) {
           focusable.focus();
         }
       }
    }
  }

  handlePanelKeydown(event, index) {
    const isArrowLeft = event.key === 'ArrowLeft';
    const isArrowUp = event.key === 'ArrowUp';
    const isArrowDown = event.key === 'ArrowDown';

    if (isArrowLeft) {
      // Return to sidebar
      event.preventDefault();
      const panel = this.panels[index];
      const panelId = panel.id;
      const link = this.querySelector(`.td-mega-menu-panel__link[data-target="${panelId}"] > a`);
      if (link) link.focus();
    } else if (isArrowUp || isArrowDown) {
      // Navigate linearly within panel
      event.preventDefault();
      const focusables = Array.from(this.panels[index].querySelectorAll('a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
      const currentIndex = focusables.indexOf(document.activeElement);
      
      let nextIndex;
      if (currentIndex === -1) {
        nextIndex = 0;
      } else if (isArrowUp) {
         nextIndex = currentIndex > 0 ? currentIndex - 1 : focusables.length - 1;
      } else {
         nextIndex = currentIndex < focusables.length - 1 ? currentIndex + 1 : 0;
      }
      
      if (focusables[nextIndex]) focusables[nextIndex].focus();
    }
  }

  initializeDefaultState() {
    // Set first panel as active by default
    if (this.panels.length > 0) {
      this.panels.forEach((panel, index) => {
        const panelId = panel.id;
        const link = this.querySelector(`.td-mega-menu-panel__link[data-target="${panelId}"] > a`);

        if (index === 0) {
          panel.dataset.active = 'true';
          if (link) link.setAttribute('aria-expanded', 'true');
        } else {
          panel.dataset.active = 'false';
          if (link) link.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  handleLinkHover(link) {
    const targetId = link.getAttribute('data-target');
    const targetPanel = this.querySelector(`#${targetId}`);
    
    // Only proceed if target panel has content
    if (!targetPanel || targetPanel.children.length === 0) {
      return;
    }
    

    // Return if the panel is marked as empty AND the link is not the first one
    if (targetPanel.classList.contains('td-mega-menu-panel__item--empty') && link !== this.links[0]) {
      return;
    }

    // Remove active state from all links
    this.links.forEach(l => {
      l.classList.remove('is-open');
      const anchor = l.querySelector('a');
      if (anchor) anchor.setAttribute('aria-expanded', 'false');
    });
    
    // Add active state to current link
    link.classList.add('is-open');
    const currentAnchor = link.querySelector('a');
    if (currentAnchor) currentAnchor.setAttribute('aria-expanded', 'true');
    
    // Hide all panels
    this.panels.forEach(panel => {
      panel.dataset.active = 'false';
    });
    
    // Show target panel
    targetPanel.dataset.active = 'true';
  }
}

// Register the custom element
if (!customElements.get('mega-menu-wrapper')) {
  customElements.define('mega-menu-wrapper', MegaMenuWrapper);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["renpho-comparison-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('renpho-comparison-product-picker')) {
    /**
     * Product picker component for RENPHO comparison table.
     * Allows users to select a replacement product from available options.
     *
     * @extends {HTMLElement}
     */
    class RenphoComparisonProductPicker extends HTMLElement {
      connectedCallback() {
        const { signal } = this.#controller;

        const productSelect = this.querySelector('select');
        if (productSelect) {
          productSelect.addEventListener('change', this.#handleChange.bind(this), { signal });
        }
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      #controller = new AbortController();

      /**
       * Handles the select change event.
       * @param {Event} event - The change event.
       */
      #handleChange(event) {
        const select = /** @type {HTMLSelectElement} */ (event.target);
        if (!select) return;

        const selectedProductId = select.value;
        const currentProductId = this.dataset.currentProductId;

        if (selectedProductId === currentProductId) {
          return;
        }

        // Dispatch custom event to swap columns
        this.dispatchEvent(
          new CustomEvent('renpho:change-product', {
            bubbles: true,
            composed: true,
            detail: {
              selectedProductId: selectedProductId,
              currentProductId: currentProductId,
              currentColumnIndex: parseInt(this.dataset.columnIndex || '0', 10),
            },
          })
        );

        // Reset select to current product ID
        select.value = currentProductId || '';
        select.blur();
      }
    }
    customElements.define('renpho-comparison-product-picker', RenphoComparisonProductPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-account-modal-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-benefits-modal')) {
  /**
   * Benefits modal component for logged-in users
   * Auto-opens when URL contains modal=benefits or benefits=true
   */
  class TdBenefitsModal extends HTMLElement {
    connectedCallback() {
      this.modalDialog = this.closest('modal-dialog');
      this.setupCloseActions();
      this.checkUrlParams();
    }

    /**
     * Sets up click handlers for elements that should close the modal
     */
    setupCloseActions() {
      const closeActions = this.querySelectorAll('.td-account-modal__close-action');

      closeActions.forEach(action => {
        action.addEventListener('click', () => {
          this.modalDialog?.hide?.();
        });
      });
    }

    checkUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const showModal = urlParams.get('modal');
      const showBenefits = urlParams.get('benefits');
      const isLoggedIn = this.dataset.loggedIn === 'true';

      if ((showModal === 'benefits' || showBenefits === 'true') && isLoggedIn) {
        const openModal = () => {
          if (!this.modalDialog?.show) return;

          const dummyOpener = document.createElement('div');
          this.modalDialog.show(dummyOpener);
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            setTimeout(openModal, 500);
          });
        } else {
          setTimeout(openModal, 500);
        }
      }
    }
  }

  customElements.define('td-benefits-modal', TdBenefitsModal);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-account-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-account-modal')) {
  /**
   * Account modal component for rewards banner sign-in/sign-up
   */
  class TdAccountModal extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.panels = [];
      this.modalDialog = null;
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleShow = this.handleShow.bind(this);
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.td-account-modal__tab'));
      this.panels = Array.from(this.querySelectorAll('.td-account-modal__tab-panel'));
      this.modalDialog = this.closest('modal-dialog');

      this.setupTabListeners();
      this.setupCloseActions();
      this.initRecoveryToggle();
      this.initTabSwitchButtons();

      if (this.modalDialog) {
        this.modalDialog.addEventListener('show', this.handleShow);
      }

      this.checkUrlParams();
    }

    /**
     * Sets up click handlers for elements that should close the modal
     */
    setupCloseActions() {
      const closeActions = this.querySelectorAll('.td-account-modal__close-action');

      closeActions.forEach(action => {
        action.addEventListener('click', () => {
          this.modalDialog?.hide?.();
        });
      });
    }

    disconnectedCallback() {
      this.tabs.forEach(tab => tab.removeEventListener('click', this.handleTabClick));

      if (this.modalDialog) {
        this.modalDialog.removeEventListener('show', this.handleShow);
      }
    }

    setupTabListeners() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick);
      });
    }

    handleTabClick(event) {
      const clickedTab = event.currentTarget;
      const targetTabName = clickedTab.dataset.tab;

      // Deactivate all tabs
      this.tabs.forEach(tab => {
        tab.classList.remove('td-account-modal__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });

      // Deactivate all panels
      this.panels.forEach(panel => {
        panel.classList.remove('td-account-modal__tab-panel--active');
        panel.hidden = true;
      });

      // Activate clicked tab
      clickedTab.classList.add('td-account-modal__tab--active');
      clickedTab.setAttribute('aria-selected', 'true');

      // Find and activate target panel
      const targetPanel = this.querySelector(`[data-panel="${targetTabName}"]`);

      if (targetPanel) {
        targetPanel.classList.add('td-account-modal__tab-panel--active');
        targetPanel.hidden = false;

        const firstInput = targetPanel.querySelector('input:not([type="hidden"]), button');

        if (firstInput) {
          setTimeout(() => firstInput.focus(), 100);
        }
      }

      // Reset signin form when switching to signin tab
      if (targetTabName === 'signin') {
        this.resetSigninForm();
      }
    }

    switchTab(targetTab) {
      const targetTabButton = this.querySelector(`[data-tab="${targetTab}"]`);

      if (targetTabButton) {
        targetTabButton.click();
      }
    }

    initTabSwitchButtons() {
      const switchButtons = this.querySelectorAll('[data-tab-switch]');

      switchButtons.forEach(button => {
        button.addEventListener('click', () => {
          this.switchTab(button.dataset.tabSwitch);
        });
      });
    }

    initRecoveryToggle() {
      const signinPanel = this.querySelector('[data-panel="signin"]');

      if (!signinPanel) return;

      const loginForm = signinPanel.querySelector('[data-form="login"]');
      const recoveryForm = signinPanel.querySelector('[data-form="recovery"]');

      if (!loginForm || !recoveryForm) return;

      const showRecoveryBtn = signinPanel.querySelector('[data-show-recovery="true"]');
      const showLoginBtn = signinPanel.querySelector('[data-show-login="true"]');

      if (showRecoveryBtn) {
        showRecoveryBtn.addEventListener('click', () => {
          loginForm.classList.remove('td-account-modal__form-view--active');
          loginForm.hidden = true;
          recoveryForm.classList.add('td-account-modal__form-view--active');
          recoveryForm.hidden = false;

          const firstInput = recoveryForm.querySelector('input:not([type="hidden"])');

          if (firstInput) {
            setTimeout(() => firstInput.focus(), 100);
          }
        });
      }

      if (showLoginBtn) {
        showLoginBtn.addEventListener('click', () => {
          recoveryForm.classList.remove('td-account-modal__form-view--active');
          recoveryForm.hidden = true;
          loginForm.classList.add('td-account-modal__form-view--active');
          loginForm.hidden = false;

          const firstInput = loginForm.querySelector('input:not([type="hidden"])');

          if (firstInput) {
            setTimeout(() => firstInput.focus(), 100);
          }
        });
      }
    }

    resetSigninForm() {
      const signinPanel = this.querySelector('[data-panel="signin"]');

      if (!signinPanel) return;

      const loginForm = signinPanel.querySelector('[data-form="login"]');
      const recoveryForm = signinPanel.querySelector('[data-form="recovery"]');

      if (loginForm && recoveryForm) {
        loginForm.classList.add('td-account-modal__form-view--active');
        loginForm.hidden = false;
        recoveryForm.classList.remove('td-account-modal__form-view--active');
        recoveryForm.hidden = true;
      }
    }

    handleShow(event) {
      let targetTab = 'signup';

      const openedBy = this.modalDialog?.openedBy;

      if (openedBy) {
        const opener = openedBy.closest('modal-opener');

        if (opener?.dataset.tab) {
          targetTab = opener.dataset.tab;
        }
      }

      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get('mode') === 'signin') {
        targetTab = 'signin';
      }

      this.switchTab(targetTab);
      this.resetSigninForm();
    }

    checkUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const showModal = urlParams.get('modal');
      const showBenefits = urlParams.get('benefits');
      const isLoggedIn = this.dataset.loggedIn === 'true';

      if (showModal !== 'benefits' && showBenefits !== 'true') return;

      const openModal = () => {
        if (!this.modalDialog?.show) return;

        const benefitsSection = this.querySelector('.td-account-modal__benefits');
        const promoSection = this.querySelector('.td-account-modal__promo');
        const formsSection = this.querySelector('.td-account-modal__forms');

        if (isLoggedIn) {
          if (benefitsSection) benefitsSection.style.display = 'block';
          if (promoSection) promoSection.style.display = 'none';
          if (formsSection) formsSection.style.display = 'none';
        } else {
          if (benefitsSection) benefitsSection.style.display = 'none';
          if (promoSection) promoSection.style.display = 'block';
          if (formsSection) formsSection.style.display = 'block';
        }

        const dummyOpener = document.createElement('div');
        dummyOpener.dataset.tab = 'signup';
        this.modalDialog.show(dummyOpener);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(openModal, 500);
        });
      } else {
        setTimeout(openModal, 500);
      }
    }
  }

  customElements.define('td-account-modal', TdAccountModal);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-comparison-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-comparison-product-picker')) {
    /**
     * Product picker component for comparison table.
     * Allows users to select a replacement product from available options.
     *
     * @extends {HTMLElement}
     */
    class TdComparisonProductPicker extends HTMLElement {
      connectedCallback() {
        const { signal } = this.#controller;

        const productSelect = this.querySelector('select');
        if (productSelect) {
          productSelect.addEventListener('change', this.#handleChange.bind(this), { signal });
        }
      }

      disconnectedCallback() {
        this.#controller.abort();
      }

      #controller = new AbortController();

      /**
       * Handles the select change event.
       * @param {Event} event - The change event.
       */
      #handleChange(event) {
        const select = /** @type {HTMLSelectElement} */ (event.target);
        if (!select) return;

        const selectedProductId = select.value;
        const currentProductId = this.dataset.currentProductId;

        if (selectedProductId === currentProductId) {
          return;
        }

        // Dispatch custom event to swap columns
        this.dispatchEvent(
          new CustomEvent('td:change-product', {
            bubbles: true,
            composed: true,
            detail: {
              selectedProductId: selectedProductId,
              currentProductId: currentProductId,
              currentColumnIndex: parseInt(this.dataset.columnIndex || '0', 10),
            },
          })
        );

        // Reset select to current product ID
        select.value = currentProductId || '';
        select.blur();
      }
    }
    customElements.define('td-comparison-product-picker', TdComparisonProductPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-custom-localization-picker"] && !Shopify.designMode) return;
  try {
    class TdCustomLocalizationPicker extends HTMLElement {
  constructor() {
    super();
    // No Shadow DOM
    /** @type {boolean} */
    this._initialized = false;
    /** @type {((e: MouseEvent) => void) | null} */
    this._handleClick = null;
    /** @type {((e: MouseEvent) => void) | null} */
    this._documentClickHandler = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.mobile = window.innerWidth < 1024;

    // Verify elements exist before setting up listeners
    const pickerTrigger = this.querySelector(".js-picker-trigger");
    const dropdown = this.querySelector(".js-dropdown");
    
    if (!pickerTrigger || !dropdown) {
      return;
    }

    // We attach the click listener to the component itself to catch events bubbling up
    // But importantly, we need to bind the handler so 'this' refers to the component
    this._handleClick = this.handleClick.bind(this);
    this.addEventListener("click", this._handleClick);

    // Close dropdown when clicking outside
    this._documentClickHandler = (e) => {
      // Check if the click is outside this component
      if (e.target instanceof Node && !this.contains(e.target)) {
          this.closeDropdown();
      }
    };
    document.addEventListener("click", this._documentClickHandler);
  }
  
  handleClick(e) {
      const target = e.target;
      if (!(target instanceof Element)) return;

      const pickerTrigger = this.querySelector(".js-picker-trigger");
      const dropdown = this.querySelector(".js-dropdown");
      if (!(pickerTrigger instanceof HTMLElement) || !(dropdown instanceof HTMLElement)) return;
      
      // Check if click is on trigger or inside trigger
      const clickedTrigger = target === pickerTrigger || pickerTrigger.contains(target);
      
      // Handle Trigger Click
      if (clickedTrigger) {
        e.stopPropagation();
        e.preventDefault();
        
        const isOpen = dropdown.classList.contains("open");
        
        if (isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
        return;
      }
      
      // Handle Item Click
      const clickedItem = target.closest && target.closest(".js-dropdown-item");
      if (clickedItem && clickedItem instanceof HTMLElement) {
        this.closeDropdown();
        return;
      }
  }
  
  disconnectedCallback() {
      if (this._documentClickHandler) {
          document.removeEventListener("click", this._documentClickHandler);
      }
      if (this._handleClick) {
        this.removeEventListener("click", this._handleClick);
      }
      this._initialized = false;
  }

  openDropdown() {
    const dropdown = this.querySelector(".js-dropdown");
    const pickerTrigger = this.querySelector(".js-picker-trigger");
   
    
    if (dropdown instanceof HTMLElement) {
        this.mobile = window.innerWidth < 1024;
        dropdown.classList.add("open");
        dropdown.style.visibility = 'visible';
        dropdown.style.opacity = '1';
        dropdown.style.transform = 'translateY(0)';
        if (this.mobile) {
          dropdown.style.height = `${dropdown.scrollHeight}px`;         
        } else {
          dropdown.style.height = '';         
        }
    }
    
    if (pickerTrigger) {
        pickerTrigger.classList.add("active");
        pickerTrigger.setAttribute("aria-expanded", "true");
    }
  }

  closeDropdown() {
    const dropdown = this.querySelector(".js-dropdown");
    const pickerTrigger = this.querySelector(".js-picker-trigger");
    
    if (dropdown instanceof HTMLElement) {
        dropdown.classList.remove("open");
        dropdown.style.visibility = '';
        dropdown.style.opacity = '';
        dropdown.style.transform = '';
        dropdown.style.height = '';
    }
    
    if (pickerTrigger) {
        pickerTrigger.classList.remove("active");
        pickerTrigger.setAttribute("aria-expanded", "false");
    }
  }
}

if (!customElements.get("td-custom-localization-picker")) {
  customElements.define("td-custom-localization-picker", TdCustomLocalizationPicker);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-custom-select"] && !Shopify.designMode) return;
  try {
    /**
   * CustomSelect - Fully customizable select replacement with keyboard accessibility
   * @extends HTMLElement
   */
  class CustomSelect extends HTMLElement {
    static #openInstance = null;

    /** @type {HTMLElement[]} */
    #options = [];
    #focusedIndex = -1;

    connectedCallback() {
      this.select = this.querySelector('select');
      if (!this.select) return;

      this.#buildUI();
      this.#bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onOutsideClick);
      this.#label?.removeEventListener('click', this.#onLabelClick);

      if (CustomSelect.#openInstance === this) {
        CustomSelect.#openInstance = null;
      }
    }

    /** @returns {HTMLLabelElement|null} */
    get #label() {
      return this.select.labels?.[0] || document.querySelector(`label[for="${this.select.id}"]`);
    }

    #buildUI() {
      // Remove existing UI elements if they exist (prevents duplicates on reconnect)
      const existingTrigger = this.querySelector('.custom-select__trigger');
      const existingOptions = this.querySelector('.custom-select__options');
      if (existingTrigger) existingTrigger.remove();
      if (existingOptions) existingOptions.remove();

      // Reset options array
      this.#options = [];

      // Trigger element
      this.trigger = document.createElement('div');
      this.trigger.className = 'custom-select__trigger';
      this.trigger.setAttribute('tabindex', '0');
      this.trigger.setAttribute('role', 'combobox');
      this.trigger.setAttribute('aria-haspopup', 'listbox');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.setAttribute('aria-controls', `${this.select.id}-listbox`);

      // Text content
      this.triggerText = document.createElement('span');
      this.trigger.appendChild(this.triggerText);
      this.#updateTriggerText();

      // Icon from template
      const iconTemplate = this.querySelector('.custom-select__icon-template');
      if (iconTemplate) {
        this.trigger.appendChild(iconTemplate.content.cloneNode(true));
      }

      // Options dropdown
      this.optionsEl = document.createElement('div');
      this.optionsEl.className = 'custom-select__options';
      this.optionsEl.setAttribute('role', 'listbox');
      this.optionsEl.id = `${this.select.id}-listbox`;

      Array.from(this.select.options).forEach((option, index) => {
        const optionEl = document.createElement('div');
        optionEl.className = 'custom-select__option';
        optionEl.setAttribute('role', 'option');
        optionEl.setAttribute('data-value', option.value);
        optionEl.setAttribute('data-index', index);
        optionEl.id = `${this.select.id}-option-${index}`;
        optionEl.textContent = option.textContent;

        if (index === this.select.selectedIndex) {
          optionEl.classList.add('custom-select__option--selected');
          optionEl.setAttribute('aria-selected', 'true');
        }

        optionEl.addEventListener('click', () => this.#selectOptionByIndex(index));
        this.optionsEl.appendChild(optionEl);
        this.#options.push(optionEl);
      });

      this.appendChild(this.trigger);
      this.appendChild(this.optionsEl);
    }

    #bindEvents() {
      this.trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.#toggle();
      });
      this.trigger.addEventListener('keydown', this.#onKeydown);
      document.addEventListener('click', this.#onOutsideClick);

      // Label association
      const label = this.#label;
      if (label) {
        if (!label.id) label.id = `${this.select.id}-label`;
        this.trigger.setAttribute('aria-labelledby', label.id);
        label.addEventListener('click', this.#onLabelClick);
      }
    }

    #onLabelClick = (e) => {
      e.preventDefault();
      this.trigger.focus();
    };

    #onKeydown = (e) => {
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          if (this.isOpen && this.#focusedIndex >= 0) {
            this.#selectOptionByIndex(this.#focusedIndex);
          } else {
            this.#toggle();
          }
          break;

        case 'Escape':
          if (this.isOpen) {
            e.preventDefault();
            this.close();
            this.trigger.focus();
          }
          break;

        case 'ArrowDown':
          if (!this.isOpen) {
            e.preventDefault();
            this.open();
          } else {
            this.#focusOption(this.#focusedIndex + 1);
          }
          break;

        case 'ArrowUp':
          if (this.isOpen) {
            e.preventDefault();
            this.#focusOption(this.#focusedIndex - 1);
          }
          break;

        case 'Home':
          if (this.isOpen) {
            e.preventDefault();
            this.#focusOption(0);
          }
          break;

        case 'End':
          if (this.isOpen) {
            e.preventDefault();
            this.#focusOption(this.#options.length - 1);
          }
          break;

        case 'Tab':
          if (this.isOpen) {
            this.close();
          }
          break;
      }
    };

    #onOutsideClick = (e) => {
      if (this.isOpen && !this.contains(e.target)) {
        this.close();
      }
    };

    #toggle() {
      this.isOpen ? this.close() : this.open();
    }

    /**
     * Focus an option by index
     * @param {number} index
     */
    #focusOption(index) {
      if (this.#options.length === 0) return;

      // Wrap around
      if (index < 0) index = this.#options.length - 1;
      if (index >= this.#options.length) index = 0;

      // Remove previous focus
      this.#options.forEach((opt) => opt.classList.remove('custom-select__option--focused'));

      // Set new focus
      this.#focusedIndex = index;
      const optionEl = this.#options[index];
      optionEl.classList.add('custom-select__option--focused');

      // Update aria-activedescendant
      this.trigger.setAttribute('aria-activedescendant', optionEl.id);

      // Scroll into view if needed
      optionEl.scrollIntoView({ block: 'nearest' });
    }

    open() {
      if (CustomSelect.#openInstance && CustomSelect.#openInstance !== this) {
        CustomSelect.#openInstance.close();
      }
      this.setAttribute('data-open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      CustomSelect.#openInstance = this;

      // Focus the currently selected option
      this.#focusedIndex = this.select.selectedIndex;
      this.#focusOption(this.#focusedIndex);
    }

    close() {
      this.removeAttribute('data-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.removeAttribute('aria-activedescendant');

      // Clear focus styling
      this.#options.forEach((opt) => opt.classList.remove('custom-select__option--focused'));
      this.#focusedIndex = -1;

      if (CustomSelect.#openInstance === this) {
        CustomSelect.#openInstance = null;
      }
    }

    get isOpen() {
      return this.hasAttribute('data-open');
    }

    /**
     * Select option by index
     * @param {number} index
     */
    #selectOptionByIndex(index) {
      const optionEl = this.#options[index];
      if (!optionEl) return;

      const value = optionEl.getAttribute('data-value');
      this.select.value = value;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));

      this.#updateTriggerText();
      this.#options.forEach((el) => {
        el.classList.remove('custom-select__option--selected');
        el.removeAttribute('aria-selected');
      });
      optionEl.classList.add('custom-select__option--selected');
      optionEl.setAttribute('aria-selected', 'true');

      this.close();
      this.trigger.focus();
    }

    #updateTriggerText() {
      const selected = this.select.options[this.select.selectedIndex];
      this.triggerText.textContent = selected?.textContent || '';
    }
  }

  if (!customElements.get('custom-select')) {
    customElements.define('custom-select', CustomSelect);
  }
  } catch(e) { console.error(e); }
})();

})();
